import * as React from 'react'
import { useEffect, useState } from 'react'
import { DrawerWrapper } from '@/components'
import { GHGEmissionsReport } from './GHGEmissionsReport'
import { GHGEmissionsDrawer } from '../GHGEmissionsDrawer/GHGEmissionsDrawer'
import useSustainabilityStore from '../../stores/useSustainabilityStore/useSustainabilityStore'
import { GHGEmissionsActions } from './GHGEmissionsActions/GHGEmissionsActions'
import { useSustainabilityHeaderSlot } from '../SustainabilityHeaderSlot/useSustainabilityHeaderSlot'
import { useSustainabilityFiltersStore } from '../../hooks/useSustainabilityFiltersStore'
import { useElementWidth, useFiltersStore } from '@/hooks'
import { mapFiltersToParams } from '@/features/Reporting/components/ReportEdit/mapFiltersToParams'
import { useGHGEmissionsFiltersGetParams } from '../../hooks/useGHGEmissionsFiltersGetParams'
import { useScope2TypeAvailability } from '../../hooks/useScope2TypeAvailability'
import { useFeatureFlag } from '@/components/providers/FeatureFlagsProvider/useFeatureFlag'

export const GHGEmissions: React.FC = () => {
    const { setSlot } = useSustainabilityHeaderSlot()
    const [isOpen, setIsOpen] = useState(false)
    const toggleButtonRef = React.useRef<HTMLButtonElement>(null)
    const toggleWidth = useElementWidth(toggleButtonRef)
    const calculationMethodOffset = isOpen ? 16 : toggleWidth

    const isDataManagementEnabled = useFeatureFlag('dataManagement')

    const activeFilters = useSustainabilityFiltersStore(
        (state) => state.activeFilters
    )
    const rootNode = useFiltersStore((state) => state.rootNode)

    const filterParams = mapFiltersToParams(activeFilters)

    if (filterParams.nodeIds.length === 0 && rootNode?.nodeId !== undefined) {
        filterParams.nodeIds = [rootNode.nodeId]
    }

    const reportSettings = useSustainabilityStore(
        (state) => state.ghgEmissions.reportSettings
    )

    const setReportSettings = useSustainabilityStore(
        (state) => state.ghgEmissions.setReportSettings
    )

    const { isMarketBasedScope2Available, isFetched } =
        useScope2TypeAvailability({
            reportSettings,
            setReportSettings,
        })

    const processedFilters = useGHGEmissionsFiltersGetParams(
        activeFilters,
        reportSettings
    )

    useEffect(() => {
        setSlot(<GHGEmissionsActions filters={processedFilters} />)
        return () => {
            setSlot(null)
        }
    }, [processedFilters, setSlot])

    return (
        <DrawerWrapper>
            <GHGEmissionsDrawer
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                toggleButtonRef={toggleButtonRef}
                reportSettings={reportSettings}
                setReportSettings={setReportSettings}
                isMarketBasedScope2Available={isMarketBasedScope2Available}
                isDataReady={!isDataManagementEnabled || isFetched}
            />
            <GHGEmissionsReport
                calculationMethodOffset={calculationMethodOffset}
                isOpen={isOpen}
                filters={activeFilters}
                reportSettings={reportSettings}
            />
        </DrawerWrapper>
    )
}
